import React from 'react';
import PropTypes from 'prop-types';
import {Query} from 'react-apollo';

export const IsAdminContext = React.createContext({});

export function withIsAdmin(queryOrComponent) {
  if (!queryOrComponent)
    throw Error(
      'This enhancer expects a gql query when acting as a provider, or a component when acting as a consumer.'
    );
  const query = queryOrComponent;
  return function(Component) {
    const IsAdminProvider = ({company, userId, ...restProps}) => {
      if (!company)
        return (
          <IsAdminContext.Provider value={false}>
            <Component {...restProps} company={company} userId={userId} />
          </IsAdminContext.Provider>
        );

      return (
        <Query query={query} variables={{id: company.id}}>
          {({loading, error, data}) => {
            const hasData = data?.company;
            const companyMembers = hasData?.companyMembers;
            let isAdmin = false;

            if (!loading && !error && hasData)
              isAdmin = companyMembers.edges.some(
                member => member.node.user.id === userId && member.node.role === 'admin'
              );
            return (
              <IsAdminContext.Provider value={isAdmin}>
                <Component company={company} userId={userId} {...restProps} />
              </IsAdminContext.Provider>
            );
          }}
        </Query>
      );
    };
    IsAdminProvider.propTypes = {
      company: PropTypes.object,
      userId: PropTypes.string
    };
    return IsAdminProvider;
  };
}
